import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { EnumTipologiaConsumoPasto, GestioneSituazioneGiornalieraNidoInfanziaLattanti, StrumentoDiRegistrazioneArchivio } from '@gpi/lbl/shared/entity';

@Component({
  selector: 'lbl-app-ui-strumento-registrazione-gestione-situazione-giornaliera-nido-infanzia-lattanti',
  templateUrl: './strumento-registrazione-gestione-situazione-giornaliera-nido-infanzia-lattanti.component.html',
  styleUrls: ['./strumento-registrazione-gestione-situazione-giornaliera-nido-infanzia-lattanti.component.scss'],
})
export class StrumentoRegistrazioneGestioneSituazioneGiornalieraNidoInfanziaLattantiComponent implements OnInit {
  @Input() strumentiDiRegistrazioneArchivio: StrumentoDiRegistrazioneArchivio[];
  @Output() updatedStrumentiDiRegistrazioneArchivio = new EventEmitter();

  displayedColumns: string[] = ['bambino', 'assente', 'frutta', 'merenda', 'sonnoPomeriggioDalle', 'sonnoPomeriggioAlle', 'feci', 'note'];
  arrayConsumoPasto: string[] = [
    EnumTipologiaConsumoPasto.Assaggiato,
    EnumTipologiaConsumoPasto.InParte,
    EnumTipologiaConsumoPasto.Meta,
    EnumTipologiaConsumoPasto.NonConsumato,
    EnumTipologiaConsumoPasto.PastoNonPresente,
    EnumTipologiaConsumoPasto.Tutto];
  formGruop: FormGroup;
  row;
  constructor(
    private fb: FormBuilder) {

  }

  ngOnInit(): void {
    this.formGruop = this.fb.group({
      rows: this.fb.array([]),
    });
    this.strumentiDiRegistrazioneArchivio.sort((a, b) => a.personeCoinvolte[0].cognome > b.personeCoinvolte[0].cognome ? 1 : -1);

    this.strumentiDiRegistrazioneArchivio.forEach((strumento, index) => {
      let content: GestioneSituazioneGiornalieraNidoInfanziaLattanti = null;
      if (strumento.content) {
        content = strumento.content as GestioneSituazioneGiornalieraNidoInfanziaLattanti;
      } else {
        content = new GestioneSituazioneGiornalieraNidoInfanziaLattanti();
      }

      content.assente ? content.assente = true : content.assente = false;
      const bambino = strumento.personeCoinvolte[0];
      this.formArray.push(this.fb.group({
        bambino: `${bambino.nome} ${bambino.cognome}`,
        assente: content.assente,
        frutta: content.frutta,
        merenda: content.merenda,
        sonnoPomeriggioDalle: content.sonnoPomeriggioDalle,
        sonnoPomeriggioAlle: content.sonnoPomeriggioAlle,
        feci: content.feci,
        note: content.note,
      }));

      const row = this.formArray.get(`${index}`);
      content.assente ? row.disable() : row.enable();

    });
    this.updatedStrumentiDiRegistrazioneArchivio.emit(this.buildStrumentoForm());

    this.formArray.valueChanges.subscribe(() => {
      this.updatedStrumentiDiRegistrazioneArchivio.emit(this.buildStrumentoForm());
    });
  }

  get formArray() {
    return <FormArray>this.formGruop.get('rows');
  }

  changeCheckBox(event, index) {
    this.row = this.formArray.get(`${index}`);
    // this.row.valueChanges.subscribe((el) => el.assente = event.checked);
    if (event.checked) {
      this.formArray.get(`${index}`).get('assente').setValue(event.checked);
      // this.strumentiDiRegistrazioneArchivio[index].content.assente = event.checked;
      this.row.disable();
    } else {
      this.formArray.get(`${index}`).get('assente').setValue(event.checked);
      // this.strumentiDiRegistrazioneArchivio[index].content.assente = event.checked;
      this.row.enable();
    }
  }

  buildStrumentoForm() {

    this.strumentiDiRegistrazioneArchivio.forEach((strumento, index) => {
      const form = this.formArray.getRawValue()[index];

      delete form.bambino;
      strumento.content = form;
    });

    return this.strumentiDiRegistrazioneArchivio;
  }

}
